import './event.scss'
import { RichText } from 'prismic-reactjs'
import linkResolver from '../../helpers/linkResolver'

export default ({ headline, description, dateInfo, dates }) => (
  <div className="article-event">
    <div className="info">
      {headline}
      {description}
    </div>
    <div className="dates">
      {dates.map((date, i) => (
        <div key={`date-${i}`} className="date">
          <div className="date-data">{RichText.render(date.date, linkResolver)}</div>
          <div className="time-data">{RichText.render(date.time, linkResolver)}</div>
        </div>
      ))}
      <div className="date-info">{dateInfo}</div>
    </div>
  </div>
)
